import React from "react";
import { Helmet } from "react-helmet";
import { buildHeadTags } from "../seo/metaTags";

/**
 * Per-page <head> tags. The tag list comes from src/seo/metaTags.js, the same code the
 * build-time prerender uses, so what crawlers see and what the app renders can't drift.
 */
const PageSEO = ({ title, description, image, path, type, noindex, schema }) => {
  const tags = buildHeadTags({ title, description, image, path, type, noindex });
  const schemas = !schema ? [] : Array.isArray(schema) ? schema : [schema];

  return (
    <Helmet>
      {tags.map((t, i) => {
        if (t.tag === "title") return <title key="title">{t.text}</title>;
        if (t.tag === "link") return <link key={i} {...t.attrs} />;
        return <meta key={i} {...t.attrs} />;
      })}
      {schemas.map((s, i) => (
        <script key={"schema-" + i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default PageSEO;
